import { Component, Input, OnInit } from '@angular/core';
import { ListingMetadataLego } from '../../shared/dto/listing-metadata.lego';

@Component({
  selector: 'wl-listing-lego-summary',
  templateUrl: './listing-lego-summary.component.html',
  styleUrls: ['./listing-lego-summary.component.less'],
    standalone: false
})
export class ListingLegoSummaryComponent implements OnInit {
  @Input() listingData: ListingMetadataLego;

  constructor() {}

  ngOnInit(): void {}
}
